import { useRouter } from '@v2/commons/utils/navigation'
import {
  selectCurrentOrganization,
  selectPolicies,
} from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

export const AdministrationContainer = () => {
  //TODO migrate to new version
  const router = useRouter()

  const organization = useAppSelector(selectCurrentOrganization)

  const policies = useAppSelector(selectPolicies)

  const handleUsers = () => {
    router.push('administration/users')
  }

  const handleRoles = () => {
    router.push('administration/roles')
  }

  const handlePolicies = () => {
    router.push('administration/policies')
  }

  const handleABCs = () => {
    router.push('administration/abcs')
  }

  const handleEmailTemplate = () => {
    router.push('administration/email-template')
  }

  const handleTags = () => {
    router.push('administration/tags')
  }
  const isEnableEmailTemplates = policies.some(
    (policie) => policie === 'is_email_template_admin_feature_enabled',
  )

  return {
    handleRoles,
    handleUsers,
    handlePolicies,
    handleABCs,
    handleEmailTemplate,
    handleTags,
    isEnableEmailTemplates,
    organization,
  }
}
